export enum EmailTemplate {
    SPLIT_PAY_INVITE = "purchase.split_payment.invite",
    PURCHASE_CONFIRMATION = "purchase.confirmation",
    PURCHASE_RECEIPT = "purchase.receipt",
    PURCHASE_REMINDER_WAIVER = "purchase.reminder.waiver",
    PURCHASE_GIFT_CERTIFICATE = "purchase.gift.certificate",
    WAITLIST_INVITED_TRAVELER = "waitlist_purchase_invited_traveler",
    ORDER_CONFIRMATION = "order.confirmation",
    TEMPLATE_COMMUNICATION_EMAIL = "communication.email",
    TEMPLATE_COMMUNICATION_SMS = "communication.sms",
}
